"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SendSmtpEmailTo1 {
    static getAttributeTypeMap() {
        return SendSmtpEmailTo1.attributeTypeMap;
    }
}
SendSmtpEmailTo1.discriminator = undefined;
SendSmtpEmailTo1.attributeTypeMap = [
    {
        "name": "email",
        "baseName": "email",
        "type": "string"
    },
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    }
];
exports.SendSmtpEmailTo1 = SendSmtpEmailTo1;
//# sourceMappingURL=sendSmtpEmailTo1.js.map